import {useMutation, useQuery} from "react-query"
import axios from "axios"
import {getAuthConfig, getValidateConfig} from "../utils";
const auth = getAuthConfig()
const validateConfig = getValidateConfig()

export function PostUploadValidate() {
    return useMutation('postUploadValidate', uploadFileData => {
        const data = axios.post(
            "/api/v2/contactuploadvalidate.php/",
            uploadFileData,
            validateConfig
        )
        return data
    })
}

export function PostUploadSave() {
    return useMutation('postUploadSave', saveData => {
        const data = axios.post(
            "/api/v2/contactuploadsave.php/",
            saveData
        )
        return data
    })
}

export function GetSMSCountryCode() {
    return useQuery("countryCode", async () => {
        const { data } = await axios.get(
            "/api/v2/config.php/sms/countryCode",
            auth
        )
        return data
    })
}

export function GetColumnConfig() {
    return useQuery("columnConfig", async () => {
        const { data } = await axios.get(
            "/api/v2/config.php/columns/contact",
            auth
        )
        return data
    })
}

export function PostUserUploadValidate() {
    return useMutation('postUserUploadValidate', uploadFileData => {
        const data = axios.post(
            "/api/v2/annieuseruploadvalidate.php/",
            uploadFileData,
            validateConfig
        )
        return data
    })
}

export function PostUserUploadSave() {
    return useMutation('postUserUploadSave', saveData => {
        const data = axios.post(
            "/api/v2/annieuseruploadsave.php/",
            saveData
        )
        return data
    })
}

export function PostAnnieUser() {
    return useMutation('annieuser', userSurveyData => {
        const data = axios.post(
            "/api/v2/annieuser.php/",
            userSurveyData,
            auth
        )
        return data
    })
}

export function PostTranslation() {
    return useMutation('translationpost', postData => {
        const data = axios.post(
            "/api/v2/translation.php/",
            postData,
            auth
        )
        return data
    })
}

export function GetContactsAndRoles() {
    return useQuery("contactRoleAnnieUsers", async () => {
        if (process.env.REACT_APP_USE_TEST_DATA === 'true') {
            const { generateTestContacts } = await import('../utils/generateTestContacts')
            return generateTestContacts(40000)
        }
        const { data } = await axios.get(
            "/api/v2/contactroleannieusers.php/",
            auth
        )
        return data
    }, {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: 5 * 60 * 1000,
    })
}

export function GetContactMeta() {
    return useQuery("contactMeta", async () => {
        const { data } = await axios.get(
            "/api/v2/codes.php/contactmeta",
            auth
        )
        return data
    }, {
        staleTime: 30 * 1000,
        refetchInterval: 60 * 1000,
    })
}

export function GetUserMeta() {
    return useQuery("userMeta", async () => {
        const { data } = await axios.get(
            "/api/v2/codes.php/usermeta",
            auth
        )
        return data
    }, {
        refetchOnWindowFocus: true,
        staleTime: 5 * 60 * 1000,
    })
}
